import FullPageLoader from "@Components/FullPageLoader";
import loadable from "@loadable/component";
import loadData from "./data";
import ErrorBoundary from "@Components/ErrorBoundary";
import usePropertyPage from "./usePropertyPage";

const PropertyPage = loadable(() => import("./PropertyPage"), {
  fallback: <FullPageLoader />,
});

const NotFound = loadable(() => import("@Pages/NotFound"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => {
  const { isError, isLoading, showFullPageLoader, isStatus500, isInternal, hasDataForCanonical } =
    usePropertyPage(props);

  const canonicalName = props?.match?.params?.id;

  if (isError) {
    return <NotFound isStatus500={isStatus500} {...props} />;
  }

  if (showFullPageLoader && !hasDataForCanonical) {
    return <FullPageLoader />;
  }

  return (
    <ErrorBoundary>
      <PropertyPage
        isLoading={isLoading || showFullPageLoader}
        isInternal={isInternal}
        canonicalName={canonicalName}
      />
    </ErrorBoundary>
  );
};
export { PropertyPage as PreFetchPropertyPage };
export { loadData };

/** Preload PropertyPage bundle so view transitions capture the gallery, not the loadable fallback. */
export const preloadPropertyPage = () => PropertyPage.load();
